import {
    Box,
    Button,
    Checkbox,
    FormControlLabel,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography,
} from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import AddIcon from "@material-ui/icons/Add"
import DeleteIcon from "@material-ui/icons/Delete"
import ListIcon from "@material-ui/icons/List"
import SendIcon from "@material-ui/icons/Send"
import { useSnackbar } from "../../../utils/notificacoes"
import React, { useEffect } from "react"
import { useHistory } from "react-router-dom"
import { excluirTemplateWpp } from "../../../services/integracaoWhatsapp"
import useLoadingStore from "../../../stores/LoadingStore"
import { IntegracaoWhatsappActionsTypes } from "../context/integracaoWhatsappActions"
import { useIntegracaoWhatsappContext } from "../context/useIntegracaoWhatsappContext"

const useStyles = makeStyles(theme => ({
    container: {
        paddingLeft: "90px",
        paddingRight: "10px",
        paddingTop: "100px",
        paddingBottom: "30px",
        [theme.breakpoints.down("md")]: {
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "80px",
        },
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingTop: "70px",
        },
    },
    content: {
        margin: "auto",
        maxWidth: "900px",
        [theme.breakpoints.down("sm")]: { maxWidth: "100%" },
    },
    configCard: {
        borderRadius: 20,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        backgroundColor: "white",
        overflow: "hidden",
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down("sm")]: { borderRadius: 15, marginBottom: theme.spacing(2) },
    },
    cardHeader: {
        backgroundColor: "#f8f9fa",
        padding: theme.spacing(2.5),
        borderBottom: "2px solid #e9ecef",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        [theme.breakpoints.down("sm")]: { padding: theme.spacing(2) },
    },
    cardHeaderTitle: {
        fontWeight: 600,
        color: "#2c3e50",
        [theme.breakpoints.down("sm")]: { fontSize: "1.1rem" },
    },
    cardContent: {
        padding: theme.spacing(3),
        [theme.breakpoints.down("sm")]: { padding: theme.spacing(2) },
    },
    infoGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
        gap: theme.spacing(2),
        marginTop: theme.spacing(2),
    },
    infoItem: {
        display: "flex",
        flexDirection: "column",
    },
    infoLabel: {
        fontSize: "0.75rem",
        color: "#7f8c8d",
        fontWeight: 600,
        textTransform: "uppercase",
        marginBottom: 2,
    },
    infoValue: {
        fontSize: "0.95rem",
        color: "#2c3e50",
        wordBreak: "break-all",
    },
    statusConectado: {
        display: "inline-flex",
        alignItems: "center",
        backgroundColor: "#e8f5e9",
        color: "#2e7d32",
        borderRadius: 20,
        padding: "4px 12px",
        fontSize: "0.85rem",
        fontWeight: 600,
        marginBottom: theme.spacing(2),
    },
    saveButton: {
        borderRadius: 25,
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        backgroundColor: "#4caf50",
        color: "white",
        boxShadow: "0 4px 12px rgba(76,175,80,0.3)",
        "&:hover": {
            backgroundColor: "#388e3c",
        },
    },
    conectarButton: {
        borderRadius: 25,
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        backgroundColor: "#1565c0",
        color: "white",
        boxShadow: "0 4px 12px rgba(21,101,192,0.3)",
        "&:hover": {
            backgroundColor: "#0d47a1",
        },
        textDecoration: "none",
    },
    novoTemplateButton: {
        borderRadius: 20,
    },
    tableContainer: {
        maxHeight: 400,
        overflowX: "auto",
    },
    templateName: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: 180,
    },
    actionCell: {
        whiteSpace: "nowrap",
    },
}))

const URL_ONBOARDING =
    "https://business.facebook.com/messaging/whatsapp/onboard/?app_id=1164178695122685&config_id=853029897306826&extras=%7B%22featureType%22%3A%22whatsapp_business_app_onboarding%22%2C%22sessionInfoVersion%22%3A%223%22%2C%22version%22%3A%22v4%22%7D"

export function IntegracaoWhatsappForm() {
    const classes = useStyles()
    const { enqueueSnackbar } = useSnackbar()
    const history = useHistory()
    const setLoading = useLoadingStore(s => s.setLoading)
    const { dados, dispatch, erroCarregamento, salvar, recarregarTemplates } =
        useIntegracaoWhatsappContext()

    useEffect(() => {
        if (erroCarregamento) enqueueSnackbar(erroCarregamento, { variant: "error" })
    }, [erroCarregamento, enqueueSnackbar])

    const configuracaoAtiva = dados.integracaoId !== null && dados.ativo && dados.conta !== ""

    const handleSalvar = async () => {
        if (!dados.wabaid.trim()) {
            enqueueSnackbar("Informe o Conta WhatsApp na Meta (WABAID).", { variant: "error" })
            return
        }
        try {
            await salvar()
            enqueueSnackbar(
                dados.ativo ? "Integração salva com sucesso!" : "Integração desativada.",
                { variant: "success" }
            )
        } catch (err) {
            enqueueSnackbar((err as Error).message || "Erro ao salvar integração.", {
                variant: "error",
            })
        }
    }

    const handleExcluirTemplate = async (nomeTemplate: string) => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const res = await excluirTemplateWpp(autorizacao, nomeTemplate)
            if (res && "retornoErro" in res) {
                enqueueSnackbar(res.mensagem || "Erro ao excluir template.", { variant: "error" })
                return
            }
            dispatch({
                type: IntegracaoWhatsappActionsTypes.REMOVER_TEMPLATE,
                payload: nomeTemplate,
            })
            enqueueSnackbar(`Template "${nomeTemplate}" excluído com sucesso.`, {
                variant: "success",
            })
        } finally {
            setLoading(false)
        }
    }

    return (
        <Box className={classes.container}>
            <Box className={classes.content}>
                {configuracaoAtiva && (
                    <Box className={classes.statusConectado}>✅ WhatsApp API conectado</Box>
                )}

                {/* Card: Configuração da Integração */}
                <Paper className={classes.configCard} elevation={0}>
                    <Box className={classes.cardHeader}>
                        <Typography variant="h6" className={classes.cardHeaderTitle}>
                            Configuração da Integração com o WhatsApp
                        </Typography>
                    </Box>
                    <Box className={classes.cardContent}>
                        <Typography variant="body2" color="textSecondary" gutterBottom>
                            Insira o código da conta do WhatsApp na Meta.{" "}
                            <a
                                href="https://docs.google.com/document/d/1UmnwGAjPULaSkM3MF_psWOn5E4HjPI6MCcSShH_lQTk/edit?tab=t.0"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Como fazer a integração
                            </a>
                        </Typography>

                        <TextField
                            label="Conta WhatsApp na Meta (WABAID)"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={dados.wabaid}
                            onChange={e =>
                                dispatch({
                                    type: IntegracaoWhatsappActionsTypes.ATUALIZAR_WABAID,
                                    payload: e.target.value,
                                })
                            }
                            style={{ marginBottom: 16 }}
                        />

                        <Box className={classes.infoGrid}>
                            {dados.conta && (
                                <Box className={classes.infoItem}>
                                    <Typography className={classes.infoLabel}>
                                        Código interno
                                    </Typography>
                                    <Typography className={classes.infoValue}>
                                        {dados.conta}
                                    </Typography>
                                </Box>
                            )}
                            {dados.telefone && (
                                <Box className={classes.infoItem}>
                                    <Typography className={classes.infoLabel}>
                                        Número WhatsApp
                                    </Typography>
                                    <Typography className={classes.infoValue}>
                                        {dados.telefone}
                                    </Typography>
                                </Box>
                            )}
                            {dados.verifiedName && (
                                <Box className={classes.infoItem}>
                                    <Typography className={classes.infoLabel}>Nome</Typography>
                                    <Typography className={classes.infoValue}>
                                        {dados.verifiedName}
                                    </Typography>
                                </Box>
                            )}
                            {dados.verificationStatus && (
                                <Box className={classes.infoItem}>
                                    <Typography className={classes.infoLabel}>Status</Typography>
                                    <Typography className={classes.infoValue}>
                                        {dados.verificationStatus}
                                    </Typography>
                                </Box>
                            )}
                            {dados.phoneNumber && (
                                <Box className={classes.infoItem}>
                                    <Typography className={classes.infoLabel}>WhatsApp</Typography>
                                    <Typography className={classes.infoValue}>
                                        {dados.phoneNumber}
                                    </Typography>
                                </Box>
                            )}
                            {dados.qualityRating && (
                                <Box className={classes.infoItem}>
                                    <Typography className={classes.infoLabel}>Rating</Typography>
                                    <Typography className={classes.infoValue}>
                                        {dados.qualityRating}
                                    </Typography>
                                </Box>
                            )}
                            {dados.webhook && (
                                <Box className={classes.infoItem}>
                                    <Typography className={classes.infoLabel}>Webhook</Typography>
                                    <Typography className={classes.infoValue}>
                                        {dados.webhook}
                                    </Typography>
                                </Box>
                            )}
                        </Box>

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={dados.ativo}
                                    onChange={e =>
                                        dispatch({
                                            type: IntegracaoWhatsappActionsTypes.ATUALIZAR_ATIVO,
                                            payload: e.target.checked,
                                        })
                                    }
                                    color="primary"
                                />
                            }
                            label="Ativo"
                            style={{ marginTop: 12, display: "block" }}
                        />

                        <Box display="flex" alignItems="center" style={{ gap: 12, marginTop: 16 }}>
                            <Button className={classes.saveButton} onClick={handleSalvar}>
                                Atualizar
                            </Button>
                            <Button
                                component="a"
                                href={URL_ONBOARDING}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={classes.conectarButton}
                            >
                                🚀 Conectar agora
                            </Button>
                        </Box>
                    </Box>
                </Paper>

                {/* Card: Templates de Mensagens */}
                <Paper className={classes.configCard} elevation={0}>
                    <Box className={classes.cardHeader}>
                        <Typography variant="h6" className={classes.cardHeaderTitle}>
                            Templates de Mensagens
                        </Typography>
                        <Box display="flex" style={{ gap: 8 }}>
                            <Button
                                variant="outlined"
                                size="small"
                                className={classes.novoTemplateButton}
                                onClick={recarregarTemplates}
                            >
                                Atualizar lista
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon={<AddIcon />}
                                className={classes.novoTemplateButton}
                                onClick={() =>
                                    history.push("/servicos/modulo/criar-template-whatsapp")
                                }
                            >
                                Novo Template
                            </Button>
                        </Box>
                    </Box>
                    <Box className={classes.cardContent}>
                        {dados.templates.length === 0 ? (
                            <Typography variant="body2" color="textSecondary">
                                Nenhum template encontrado. Configure a integração para visualizar
                                os templates.
                            </Typography>
                        ) : (
                            <TableContainer className={classes.tableContainer}>
                                <Table
                                    size="small"
                                    stickyHeader
                                    style={{ width: "100%", minWidth: 730 }}
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ minWidth: 80 }}>ID</TableCell>
                                            <TableCell style={{ minWidth: 160 }}>Nome</TableCell>
                                            <TableCell style={{ minWidth: 120 }}>Formato</TableCell>
                                            <TableCell style={{ minWidth: 120 }}>Status</TableCell>
                                            <TableCell style={{ minWidth: 130 }}>
                                                Categoria
                                            </TableCell>
                                            <TableCell style={{ minWidth: 120 }} align="center">
                                                Ações
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {dados.templates.map(t => (
                                            <TableRow key={t.id || t.name}>
                                                <TableCell>{t.id}</TableCell>
                                                <TableCell
                                                    className={classes.templateName}
                                                    title={t.name}
                                                >
                                                    {t.name}
                                                </TableCell>
                                                <TableCell>{t.parameter_format}</TableCell>
                                                <TableCell>{t.status}</TableCell>
                                                <TableCell>{t.category}</TableCell>
                                                <TableCell
                                                    align="center"
                                                    className={classes.actionCell}
                                                >
                                                    <Tooltip title="Disparar template">
                                                        <IconButton
                                                            size="small"
                                                            color="primary"
                                                            onClick={() =>
                                                                history.push(
                                                                    `/servicos/modulo/disparar-template-whatsapp/${t.name}`
                                                                )
                                                            }
                                                        >
                                                            <SendIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Ver mensagens">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() =>
                                                                history.push(
                                                                    `/servicos/modulo/mensagens-template-whatsapp/${t.name}`
                                                                )
                                                            }
                                                        >
                                                            <ListIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Excluir template">
                                                        <IconButton
                                                            size="small"
                                                            color="secondary"
                                                            onClick={() => {
                                                                if (
                                                                    window.confirm(
                                                                        `Excluir o template "${t.name}"? Esta ação é irreversível.`
                                                                    )
                                                                ) {
                                                                    handleExcluirTemplate(t.name)
                                                                }
                                                            }}
                                                        >
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    </Box>
                </Paper>
            </Box>
        </Box>
    )
}
